import { SxProps } from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import { AT_HOME_SITUATION, GUARDIAN, HOME_CARE_SITUATION } from "core/consts";
import { ValueOf } from "core/types";
import RadioGroupV2, { RadioOptionV2 } from "ds_legacy/components/RadioGroupV2";
import { RADIO_WHITE_BACKGROUND } from "ds_legacy/materials/colors";
import { margin, sizing } from "ds_legacy/materials/metrics";
import { useTranslations } from "translations";

export function useLivingSituationOptions() {
  const translations = useTranslations();
  const homeOptions: RadioOptionV2<ValueOf<typeof AT_HOME_SITUATION>>[] = [
    {
      label: translations.patientForms.generalForm.sectionI.optionAtHomeAlone,
      value: AT_HOME_SITUATION.ALONE,
    },
    {
      label:
        translations.patientForms.generalForm.sectionI
          .optionAtHomeWithRelatives,
      value: AT_HOME_SITUATION.RELATIVES,
    },
  ];

  const homeCareSituationOptions: RadioOptionV2<
    ValueOf<typeof HOME_CARE_SITUATION>
  >[] = [
    {
      label: translations.patientForms.generalForm.sectionI.optionAtHome,
      subForm: (
        <RadioGroupV2
          elementName="living_situation_at_home"
          flatModel
          formControlLabelSx={{ marginLeft: 0, paddingBottom: sizing(0.5) }}
          formControlSx={{ margin: margin(0, 0, 0, 2) }}
          formLabelSx={visuallyHidden as SxProps}
          label={
            translations.patientForms.generalForm.sectionI
              .accessibilityAtHomeSituation
          }
          options={homeOptions}
          radioSx={RADIO_WHITE_BACKGROUND}
          required
        />
      ),
      value: HOME_CARE_SITUATION.HOME,
    },
    {
      label:
        translations.patientForms.generalForm.sectionI.optionAssistedLiving,
      value: HOME_CARE_SITUATION.ASSISTED_LIVING,
    },
    {
      label: translations.patientForms.generalForm.sectionI.optionCareHome,
      value: HOME_CARE_SITUATION.CARE_HOME,
    },
  ];

  return homeCareSituationOptions;
}

export function useGuardianOptions() {
  const translations = useTranslations();
  const guardianOptions: RadioOptionV2<ValueOf<typeof GUARDIAN>>[] = [
    {
      label: translations.patientForms.generalForm.sectionI.optionCarer,
      value: GUARDIAN.CARER,
    },
    {
      label: translations.patientForms.generalForm.sectionI.optionHealthCareRep,
      value: GUARDIAN.HEALTH_CARE_REP,
    },
    {
      label: translations.patientForms.generalForm.sectionI.optionLegalRep,
      value: GUARDIAN.LEGAL_REP,
    },
  ];
  return guardianOptions;
}
